'use client';

import { useState } from 'react';

/**
 * On mobile, filters used to render above the product grid unconditionally
 * — pushing every product below the fold until the visitor scrolled past
 * five spec filters (caught via a Playwright screenshot, not a test; see
 * DECISIONS.md ADR-013). Collapsed by default under sm:, always open at
 * sm: and above where there's room for a sidebar.
 */
export function MobileFilterToggle({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="w-full sm:w-56 sm:shrink-0">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center justify-between rounded-lg border border-gray-border px-4 py-3 text-sm font-medium text-navy sm:hidden"
      >
        Filtros
        <svg
          className={`h-4 w-4 transition-transform ${open ? 'rotate-180' : ''}`}
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
            clipRule="evenodd"
          />
        </svg>
      </button>

      <div className={`${open ? 'mt-3 block' : 'hidden'} sm:mt-0 sm:!block`}>{children}</div>
    </div>
  );
}
